import { render, staticRenderFns } from "./user-select.vue?vue&type=template&id=15bc4351&scoped=true&"
import script from "./user-select.vue?vue&type=script&lang=js&"
export * from "./user-select.vue?vue&type=script&lang=js&"
import style0 from "./user-select.vue?vue&type=style&index=0&id=15bc4351&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bc4351",
  null
  
)

export default component.exports